// src/stone/icons/SignalWifi2.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SignalWifi2 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12.04 11.002a10 10 0 0 0-6.4 2.316 1 1 0 1 1-1.28-1.536 12 12 0 0 1 15.36 0 1 1 0 1 1-1.28 1.536 10 10 0 0 0-6.4-2.316" }),
      /* @__PURE__ */ jsx("path", { d: "M12 6.003A15 15 0 0 0 2.081 9.75 1 1 0 1 1 .76 8.25a17 17 0 0 1 22.482 0 1 1 0 0 1-1.322 1.5A15 15 0 0 0 12 6.003M12.005 16.001a5 5 0 0 0-2.896.924 1 1 0 0 1-1.158-1.63 7 7 0 0 1 8.108 0 1 1 0 1 1-1.158 1.63 5 5 0 0 0-2.896-.924M11 20a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1" })
    ]
  }
);
var SignalWifi2_default = SignalWifi2;

export {
  SignalWifi2_default
};
